import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/auth';
import {VERSION} from '@angular/material';
import {NavService} from './nav.service';
import {FirestoreService} from '../../services/firestore.service';
import {Router} from '@angular/router';
import {NavItem} from './nav-item';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})

export class ShellComponent implements AfterViewInit {

  public lang = localStorage.getItem('lang');
  public strings;
  public menu = [];
  public navItems: NavItem[];

  @ViewChild('appDrawer', {static: false}) appDrawer: ElementRef;
  version = VERSION;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(
    private route: Router,
    private fs: FirestoreService,
    private breakpointObserver: BreakpointObserver,
    public afAuth: AngularFireAuth,
    private navService: NavService
  ) {
    console.log(this.route.url);
    this.fs.getMenu('listMenu', this.lang).valueChanges().subscribe( menu => {
      // @ts-ignore
      this.navItems = menu.menu;
    });
  }

  ngAfterViewInit() {
    this.navService.appDrawer = this.appDrawer;
  }

}
